import React from 'react';

const Error = ({ error }) => {
	return (
		error && (
			<p className="dashboard-welcome-error" style={{ color: 'red' }}>
				{error}
			</p>
		)
	);
};

export default Error;
